import classNames from "classnames";
import React, { useContext } from "react";

import IconWarning from "../../../public/svg/icon-warning.svg";
import { ThemeContext } from "../../contexts/ThemeContext";

import css from "./ErrorContainer.module.scss";

type ErrorContainerProps = {
  message: string;
};

const ErrorContainer: React.FC<ErrorContainerProps> = ({ message }) => {
  const { styles } = useContext(ThemeContext);
  return (
    <div className="br-pill bn bg-purple">
      <div className="flex items-center white pl1 pr2">
        <div className={classNames("pr2 flex items-center", css.warningIcon)}>
          <IconWarning data-testid="icon-warning" />
        </div>
        <span className={classNames(styles.paragraph3, "pv2")}>{message}</span>
      </div>
    </div>
  );
};

export default ErrorContainer;
